document.addEventListener('DOMContentLoaded', () => {
  const storeDetailModal = document.querySelector('[js-store-detail]');
  const moreBtns = document.querySelectorAll('[js-more-btn]');
  const details = document.querySelectorAll('[js-store-details]');
  let result = '';
  if (storeDetailModal) {
    const content = storeDetailModal.querySelector('[js-store-detail-content]');
    const overlay = storeDetailModal.querySelector('[js-store-detail-overlay]');
    const closeBtn = storeDetailModal.querySelector('[js-store-detail-closebtn]');

    moreBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const title = btn.getAttribute('data-title');

        details.forEach(detail => {
          const detailTitle = detail.getAttribute('data-title');

          if (title === detailTitle) {
            result = detail.innerHTML;
          }
        });
        content.innerHTML = result;
        storeDetailModal.classList.add('active');
        disableScroll(true);
      })
    });

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        e.preventDefault();

        storeDetailModal.classList.remove('active');
        disableScroll(false);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();

        storeDetailModal.classList.remove('active');
        disableScroll(false);
      });
    }
  }
})

function disableScroll(isDisabled) {
  if (isDisabled)
    document.body.style.overflow = 'hidden';
  else
    document.body.style.overflow = 'auto';
}